import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connect } from "react-redux";
import { getCart } from "../../stores/cartActions.js";

import { Routing } from "../shared/routing.js";
import { Localize } from "../shared/localize.js";
import { RenderTemplate } from "../shared/render-template.js";

const mapStateToProps = state => {
  return {
    cart: state.cart
  };
};
const NavMiniCart = (props) => {
  var ret = null;

  var { show } = props;

  const dispatch = useDispatch();
  const _cart = useSelector(state => state.cart.cart);

  //console.log("NavMiniCart render", cart);

  var cart = _cart || { items: [] };

  var items = cart.items || [];
  var wheels = cart.wheels || [];

  var length = items.length + wheels.length;

  var items = [];
  if (cart.items && Array.isArray(cart.items)) {
    cart.items.forEach((v, i, a) => {
      items.push(
        <tr key={"items-" + i}>
          <td><span style={{ whiteSpace: "nowrap" }}>{v.Brand} {v.Pattern} <br />{v.Width}/{v.Ratio} r{v.Diameter} {v.Load}{v.Speed}</span></td>
        </tr>
      );
    });
  }
  var miniCart = null;
  if (items.length) {
    var goToCartButton = (
      <tr key={"goToCartButton"}>
        <td><a className="btn btn-danger btn-danger-glossy" style={{ width: "100%", fontSize: "14px" }} href={"/" + Routing.R("cart")}><i className="fas fa-chevron-right"></i> {Localize.L("procedi all'ordine")}</a></td>
      </tr>
    );
    miniCart = (
      <table>
        <tbody>
          {items}
          {goToCartButton}
        </tbody>
      </table>
    );
  } else {
    miniCart = (<span>{Localize.L("Vuoto")}</span>);
  }

  // <li class="nav-item dropdown" style="fontSize:100%;">

  if (RenderTemplate.RT("render_template.phone_template") == "gomme-auto") {
    ret = (
      <div>
        <a href={"/" + Routing.R("cart")} className="nav-link ddropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
          name="NavMiniCart"
          onClick={(e) => window.location.href = "/" + Routing.R("cart")}>
          <div className="d-none d-md-inline">{Localize.L("Carrello")}</div>
          <div>
            <i className="fas fa-shopping-cart" /> <span className="badge badge-dark">{length}</span>
          </div>
        </a>
        <div className="dropdown-menu" style={{ fontSize: '100%', display: show ? "block" : "none" }}>
          {miniCart}
        </div>
      </div>
    );
  }
  else {
    ret = (
      <div>
        <a href={"/" + Routing.R("cart")} className="nav-link ddropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
          name="NavMiniCart"
          onClick={(e) => window.location.href = "/" + Routing.R("cart")}><i className="fas fa-shopping-cart" /> <span className="d-none d-md-inline">{Localize.L("Carrello")}</span> <span className="badge badge-success">{length}</span></a>
        <div className="dropdown-menu" style={{ fontSize: '100%', display: show ? "block" : "none" }}>
          {miniCart}
        </div>
      </div>
    );
  }

  return ret;
}

//const NavMiniCart = connect(mapStateToProps, mapDispatchToProps)(ConnectedNavMiniCart);
export { NavMiniCart }
